var _defs, _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficialResources = function SvgOfficialResources(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.4 63.85"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".official-resources_svg__cls{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:3}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 13.57V4.29C.5 2.19 2.24.5 4.39.5h15.92c1 0 1.97.38 2.7 1.06l12.85 12.01",
    className: "official-resources_svg__cls"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.18 13.75V6.43h43.35v7.14",
    style: {
      fill: "currentColor"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 13.57h76.12c.7 0 1.28.57 1.28 1.28v47.23c0 .7-.57 1.28-1.28 1.28H1.78c-.7 0-1.28-.57-1.28-1.28z",
    className: "official-resources_svg__cls"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.67,
    cy: 38.46,
    className: "official-resources_svg__cls",
    rx: 21.35,
    ry: 20.56
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.84 28.46c-3.41 3.64-6.49 7.69-9.1 12.36-.42.57-1.13.76-1.74.47l-5.39-2.6a.427.427 0 0 0-.55.17l-.77 1.16c-.31.47-.26 1.13.13 1.53l7.16 7.37c.43.45 1.12.35 1.45-.19 3.4-7.67 7.33-14.54 12.13-20.15.22-.36-.01-.85-.4-.85h-1.53c-.54 0-1.05.27-1.39.74Z"
  })));
};
export default SvgOfficialResources;